import { Typography } from '@mui/material'
import { FunctionComponent } from 'react'
import { IColorPalatte } from '../shared-services/public-reports.model'
import { NumericFormat } from 'react-number-format'
import { useReportContentOverride } from '../shared-services/gaia-report-content'

export const GaiaReportWebPageTextFromGraph: FunctionComponent<{
  data: string,
  emissionDetails: any
  type: string,
  section: 'emissions' | 'offset',
  inline?: boolean,
  textColor?: string,
  colorPalatte: IColorPalatte,
  /** Content-schema key that makes this data sentence editable; blank = built-in generated sentence. */
  contentKey?: string,
}> = ({
  data,
  emissionDetails,
  type,
  colorPalatte,
  section,
  inline = false,
  textColor,
  contentKey }) => {

    const getAmount = (d: any) => type === 'pie' ? d.value : d.totalEmission

    const hasMultiple = emissionDetails.length > 1
    const last = emissionDetails[emissionDetails.length - 1]
    const secondLast = emissionDetails[emissionDetails.length - 2]

    const effectiveColor = textColor ?? colorPalatte.dark

    const override = useReportContentOverride(contentKey ?? '', {
      topLabel: emissionDetails?.[0]?.label,
      topValue: emissionDetails?.[0] ? getAmount(emissionDetails[0]) : undefined,
    })

    return (
      <>
        <Typography component={inline ? 'span' : 'p'} sx={{ color: effectiveColor, fontSize: '1.1rem', display: inline ? 'inline' : 'block', m: 0 }}>
          {override ?? <>
          {!(section === 'offset') && (
            <>
              The {data} that contributed the most emissions was {emissionDetails[0].label} with <NumericFormat value={getAmount(emissionDetails[0])} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO<sub>2</sub>e
            </>
          )}
          {(section === 'offset') && (
            <>
              The largest contribution came from {emissionDetails[0].label}, accounting for <NumericFormat value={getAmount(emissionDetails[0])} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO<sub>2</sub>e
            </>
          )}
          {hasMultiple && (
            <>
              {' '}followed by {emissionDetails.slice(1, -2)
                .map((d: any, idx: number) => (
                  <span key={`mid-${idx}`}>
                    {idx > 0 ? ', ' : ''}
                    {d.label} {(section === 'offset') ? (
                      <>with <NumericFormat value={getAmount(d)} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO₂e</>
                    ) : (
                      <>with <NumericFormat value={getAmount(d)} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO₂e emissions</>
                    )}
                  </span>
                ))}
              {emissionDetails.length > 3 ? ', ' : ''}
              {emissionDetails.length > 2 ? (
                <span>
                  {secondLast.label} {(section === 'offset') ? (
                    <>with <NumericFormat value={getAmount(secondLast)} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO₂e</>
                  ) : (
                    <>with <NumericFormat value={getAmount(secondLast)} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO₂e</>
                  )}, and {last.label} {(section === 'offset') ? (
                    <>with <NumericFormat value={getAmount(last)} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO₂e.</>
                  ) : (
                    <>with <NumericFormat value={getAmount(last)} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO₂e.</>
                  )}
                </span>
              ) : (
                <span>
                  and {last.label} {(section === 'offset') ? (
                    <>with <NumericFormat value={getAmount(last)} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO₂e.</>
                  ) : (
                    <>with <NumericFormat value={getAmount(last)} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale /> tCO₂e.</>
                  )}
                </span>
              )}
            </>
          )}
          {emissionDetails.length === 1 && '.'}
          </>}
        </Typography>
      </>
    )
  }